import axios from 'axios'

export default {
  namespaced: true,
  state: {
    employeeSalaryInfo: []
  },
  mutations: {
    setEmployeeSalaryInfo(state, payload) {
      state.employeeSalaryInfo = payload
    },
  },
  getters: {
    employeeSalaryInfo: (state) => {
      return state.employeeSalaryInfo
    },
  },
  actions: {
    onEmployeeSalaryInfo({commit, rootState}, {employeeId}) {
      commit('setEmployeeSalaryInfo', {})
      let url =
        rootState.apiDomain +
        '/api/admin/employee/salary/info/' +
        employeeId
      return new Promise((resolve, reject) => {
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setEmployeeSalaryInfo', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUpdateEmployeeSalary({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/salary/info/salary',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onUpdateEmployeePremium({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/employee/salary/info/premium',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
